export default (function (strsOrRegexes) {
  return strsOrRegexes.map(function (strOrRegex) {
    return typeof strOrRegex === 'string' ? new RegExp("^".concat(strOrRegex, "$")) : strOrRegex;
  });
});